import React from 'react';
import { observer } from 'mobx-react';
import { Row } from 'react-bootstrap';
import TrendsFeatured from './TrendsFeatured';
import TrendsPostGrid from './TrendsPostGrid';
import TrendsPostsList from './TrendsPostsList';

@observer
export default class TrendsView extends React.Component {
    componentDidMount() {
        this.props.loadPosts();
    }

    render() {
        const { loadMorePosts, store } = this.props;

        return (
            <Row componentClass="main" className="trends-page">
                <div className="trends-page-header">
                    <h1 className="header-title">Bay Area market reports.</h1>
                    <p className="header-subtext">
                        The most up-to-date and comprehensive analysis of San
                        Francisco home prices, values, conditions and trends of
                        the San Francisco Bay Area residential real estate
                        market.
                    </p>
                </div>
                <TrendsFeatured store={store} />
                <TrendsPostGrid store={store} />
                <TrendsPostsList loadMorePosts={loadMorePosts} store={store} />
            </Row>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/trends/TrendsView.jsx